




































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { PMWorksheet } from '@/models/pmworksheet';
import type { Project } from '@/models/project';
import type { PMSubPhase } from '@/models/pmsubphase';
import type { PMLesson } from '@/models/pmlesson';
import type { PMPhase } from '@/models/pmphase';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';
import { pmSubPhaseWebservice } from '@/webservices/pmsubphase';
import { pmWorksheetWebservice } from '@/webservices/pmWorksheet';
import PrineButton from '@/components/prine/PrineButton.vue';
import LessonsList from '@/components/knowledge/lessons/LessonsList.vue';
import UpdateFilter from '@/components/worksheets/UpdateFilter.vue';
import { extractTagsFrom } from '@/helpers/extractTags';
import { LessonsFilter } from '@/helpers/types/LessonsFilter';
import { filterLessonContainer, filterLessons } from '@/helpers/filter/lessons/lessonsFilter';
import { allInLessonContainersSelected } from '@/helpers/filter/lessons/allInLessonContainersSelected';
import { deselectAll, selectAll } from '@/helpers/filter/lessons/selectAll';

@Component({
    name: 'UpdateWorksheetPM',
    methods: { extractTagsFrom },
    components: {
        UpdateFilter,
        PrineButton,
        LessonsList,
    },
})
export default class UpdateWorksheetPM extends Vue {
    private filters: LessonsFilter = {
        tags: [],
    };
    private checkedLessons = new Array<PMLesson>();
    private pmSubPhases = new Array<PMSubPhase>();
    private filteredPmSubPhases = new Array<PMSubPhase>();
    private selectedPMPhase: PMPhase = {} as PMPhase;

    private option: {
        filterByColumn: boolean;
        filterable: boolean;
    };
    private pmWorksheet: PMWorksheet = {} as PMWorksheet;
    private isLoading: boolean = false;
    private isReady: boolean = false;

    @Getter('project/selectedProject') private selectedProject: Project;

    @Watch('filters', { deep: true })
    private filterLessons() {
        this.filteredPmSubPhases = filterLessonContainer(
            JSON.parse(JSON.stringify(this.pmSubPhases)) as PMSubPhase[],
            this.filters
        );
    }

    get allSelected() {
        return allInLessonContainersSelected(this.filteredPmSubPhases, this.checkedLessons);
    }

    private mounted() {
        if (this.$route.query.hasOwnProperty('worksheetId')) {
            this.loadPMWorksheetById(Number(this.$route.query.worksheetId));
        } else {
            this.goBack();
        }
    }

    private goBack() {
        // Show the Worksheet View
        this.$router.push({
            name: 'WorksheetView',
            query: {
                id: this.pmWorksheet.id.toString(),
                onlyPR: this.$route.query.onlyPR,
                type: this.$route.query.type,
            },
        });
    }

    private loadPMWorksheetById(worksheetId: number) {
        pmWorksheetWebservice
            .getById(worksheetId)
            .then((response) => {
                this.pmWorksheet = response.data;
                this.loadSubPhasesWithLessons();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private loadSubPhasesWithLessons() {
        pmSubPhaseWebservice.load(this.pmWorksheet.pm_phase.id, ApprovalState.APPROVED).then((response) => {
            this.pmSubPhases = response.data;
            this.filterLessons();
            this.checkCurrentAppliedLessons();
        });
    }

    private checkCurrentAppliedLessons() {
        this.filteredPmSubPhases.forEach((subPhase) => {
            this.selectAllAppliedLessonsRec(subPhase.lessons, this.checkedLessons);
        });
        this.isReady = true;
    }

    private selectAllAppliedLessonsRec(lessons: PMLesson[], checkedLessons) {
        lessons.forEach((lesson: PMLesson) => {
            if (this.isAppliedLesson(lesson)) {
                checkedLessons.push(lesson);
            }
            if (lesson.sub_lessons) {
                this.selectAllAppliedLessonsRec(lesson.sub_lessons, checkedLessons);
            }
        });
    }

    private isAppliedLesson(lesson: PMLesson) {
        return !!this.pmWorksheet.pm_applied_lessons.find((al) => al.pm_lesson_id === lesson.id);
    }

    private selectAllClick() {
        if (this.allSelected) {
            this.checkedLessons = deselectAll(this.filteredPmSubPhases, this.checkedLessons);
        } else {
            this.checkedLessons = selectAll(this.filteredPmSubPhases, this.checkedLessons);
        }
    }

    private updateWorksheet() {
        this.isLoading = true;
        pmWorksheetWebservice
            .update(this.pmWorksheet, this.checkedLessons)
            .then((response) => {
                this.goBack();
            })
            .catch((error) => {
                console.log(error);
                this.isLoading = false;
            });
    }

    private hr(index) {
        return index > 1;
    }
}
